<ng-template #tasksInfo>
  <div class="tasks-list h-100 d-flex flex-column">
    <div class="review-plan-info mt-3 mb-2">
      <img src="../../../../images/core-focus/orange-info-icon.png"/>
      These tasks will be created for you along with the Tax Plan.
    </div>
    <div class="d-flex mb-3 flex-fill min-h-0">
      <div class="list-box d-flex flex-column">
        <div class="bold heading header-col">Tasks List</div>
        <div class="d-flex flex-column padding-10 flex-fill min-h-0 overflow-auto">
          <div class="d-flex task-section mt-2 mb-2 justify-content-between" *ngFor="let task of tasks;">
            <div class="task-name">{{task.title}}</div>
            <div class="task-value">
              <input *ngIf="!task.type" style="margin-bottom: 0;" type="text" [(ngModel)]="task.value"/>
              <input *ngIf="task.type && task.type === 'amount'"style="margin-bottom: 0;" class="float-left input-field" placeholder="" type="text" [(ngModel)]="task.value" model-numeral [locale]="'USD'" [format]="'$0,0'"/>
            </div>
            <div class="task-date">
              <input style="margin-bottom: 0;" class="float-left input-field" type="text" tpiq-custom-datepicker [attr.format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="task.dueDate"
                     placeholder="Task Due Date" (valueChanged)="setDueDate($event, task)"/>
            </div>
          </div>
          <div class="d-flex flex-column align-items-center justify-content-center no-strategies" *ngIf="tasks && tasks.length == 0">
            <div class="mt-2 text-align-center">
              <div class="text">You have no tasks to create.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
